import script from "./Association.vue?vue&type=script&setup=true&lang=js"
export * from "./Association.vue?vue&type=script&setup=true&lang=js"

import "./Association.vue?vue&type=style&index=0&id=5493ac9f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5493ac9f"]])

export default __exports__